/**
 * Google Maps Places loader — lazily loads the JS API exactly once and shares
 * the same `google` namespace across every Autocomplete instance on the page.
 *
 * Uses the v2.x functional API of @googlemaps/js-api-loader (setOptions +
 * importLibrary). The legacy `Loader` class was removed in v2.
 *
 * Usage:
 *   const google = await loadGoogleMaps();
 *   const svc = new google.maps.places.AutocompleteService();
 */
import { setOptions, importLibrary } from '@googlemaps/js-api-loader';

let _loaderPromise = null;

export const loadGoogleMaps = () => {
  if (_loaderPromise) return _loaderPromise;
  const apiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
  if (!apiKey) {
    _loaderPromise = Promise.reject(new Error('REACT_APP_GOOGLE_MAPS_API_KEY missing'));
    return _loaderPromise;
  }
  setOptions({
    key: apiKey,
    v: 'weekly',
    language: 'en',
    region: 'IN',
  });
  // Pre-load both core + places, then return the global `google`.
  _loaderPromise = Promise.all([
    importLibrary('core'),
    importLibrary('places'),
  ]).then(() => window.google);
  return _loaderPromise;
};
